import { defineStore } from 'pinia'

import config from '@/app/config';
import createAxios from '@/app/core/AxiosCore';

const axios = createAxios(config);
import sistemaApi from '@/app/services/sistema';


export const useConfigStore = defineStore('config', {

  state: () => ({
    titulo_tela: config.APP_NAME,
    loading: false,
    origin: '',
    drawerRight: false,
    configuracoes: {},
    lista_configuracoes: [],
    drawer: true,
    novas_configuracoes: {},
    conf: {
      loading: false,
      origin: ''
    },
    saving: false,
  }),

  actions: {
    async carregarConfiguracoes() {
      const configuracoes = await axios.get('configuracoes').then(response => response.data);
      this.SET_CONFIGURACOES(configuracoes);
    },

    async carregarListaConfiguracoes() {
      return await axios.get('configuracoes/lista')
        .then(response => {
          this.SET_LISTA_CONFIGURACOES(response.data);
          this.SET_NOVAS_CONFIGURACOES(response.data);
        });
    },

    async atualizar(configuracao) {
      return await axios.put('configuracoes', configuracao);
    },

    async salvar(configuracao) {
      return await axios.post('configuracoes', configuracao);
    },

    async salvarConfiguracoes(configuracao) {
      return await axios.put('configuracoes/atualizar', configuracao);
    },

    async salvarConfiguracao(configuracao) {
      try {
        this.saving = true;
        await axios.put('configuracoes/atualizar/configuracao', configuracao);
      } catch (error) {
        console.log(error);
      } finally {
        this.saving = false;
      }
    },

    async imageUpload(dados) {
      return await axios.post('imagens/upload', dados, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      });
    },

    async loadTerminalConfig() {
      const configuracoes = await sistemaApi.loadTerminalConfig();
      this.configuracoes = {...this.configuracoes, ...configuracoes};
    },


    SET_CONFIGURACOES(configuracoes) {
     this.configuracoes = configuracoes
    },

    SET_LISTA_CONFIGURACOES(configuracoes) {
     this.lista_configuracoes = configuracoes
    },

    SET_NOVAS_CONFIGURACOES(configuracoes = []) {
      const new_config = {}
      configuracoes.forEach(config => {
        new_config[config.config] = config.valor;
      });

     this.novas_configuracoes = new_config
    },

    ADD_CONFIGURACOES(configuracoes) {
      this.configuracoes = { ...this.configuracoes, ...configuracoes };
    },
  },
})
